const App = {
    getScanResult: function() {
        window["ExternalInterface"].call("getScanResult");
        return new Promise((resolve) => {
            window["ExternalInterface"].addCallback("getScanResult", function(data) {
                resolve(data);
            })
        });
    },
    getGameInfo: function(gameID) {
        window["ExternalInterface"].call("getGameInfo", gameID);
        return new Promise((resolve) => {
            window["ExternalInterface"].addCallback("getGameInfo", function(data) {
                resolve(data);
            })
        });
    },
    openURL: function(url) {
        window["ExternalInterface"].call("openURL", url);
    },
    download: function(gameID, url, version) {
        window["ExternalInterface"].call("download", JSON.stringify({
            game_id: gameID,
            download_url: url,
            version: version // TODO:增加version
        }))
        window["ExternalInterface"].addCallback("download", function(data) {
            if (typeof window.BSCallback.download == "function") {
                window.BSCallback.download(data)
            }
        })
    },
    getAppInfo: function() {
        window["ExternalInterface"].call("getAppInfo");
        return new Promise((resolve) => {
            window["ExternalInterface"].addCallback("getAppInfo", function(data) {
                resolve(data);
            })
        });
    },
    setData: function(key, value) {
        const params = {
            key: key,
            value: value
        };
        window["ExternalInterface"].call("setData", JSON.stringify(params));
    },
    removeData: function(key) {
        window["ExternalInterface"].call("removeData", key);
    },
    getData: function(key) {
        window["ExternalInterface"].call("getData", key);
        return new Promise((resolve) => {
            window["ExternalInterface"].addCallback("getData", function(data) {
                const jsonData = JSON.parse(data);
                if (jsonData.key == key) {
                    resolve(jsonData.value);
                }
            })
        });
    }
}

export default App;